import { type CustomersGoogleTypeMoney, type Google_Type_Money } from '../../../api'
import { type Money } from './types'

/**
 * TODO(FUL-173507): Revise this copied method with proper i18n support
 */
export const convertMoney = (money: CustomersGoogleTypeMoney | Google_Type_Money): Money => ({
  amount: Number(money.units || 0) + Number(money.nanos || 0) / 1000000000,
  currencyCode: money.currencyCode || 'USD',
})
